import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router";
import strings from "../../Utils/strings";
import utils from "../../Utils";
import authService from "../../Services/authService";

const ValidateSession = () => {
  const nav = useNavigate();
  const [session, setSession] = useState(false);
  useEffect(() => {
    let session = authService.getToken();
    let isDoctorLogin = authService.getIsDoctorLogin();
    if (session) {
      setSession(true);
      if (session) {
        setSession(true);
      }
    } else {
      window.location.href = strings.navigation.welcome;
    }
  }, []);
  // console.log("000", session);
  return <>{session ? <Outlet /> : null}</>;
};

export default ValidateSession;
